/**
 *  Note this file automatically generated from
 *  @link http://gitlab.fimacomarketing.com:10080/ProninE/BGServerGame/tree/master/ServerPHP/daemon/daemon_node/public/minigames/coin/MinigameMathCoin.js
 */
'use strict';
import { MinigameMathCommon } from '../common/MinigameMathCommon'

/**
 * MinigameCoinMath class.
 *
 * About classes  https://learn.javascript.ru/class-inheritance
 * @inheritDoc
 */

export function MinigameMathCoin(socket) {
    const MINIGAME_ID_COIN = 1;

    this.ACTION_TAKE = "doTake";
    this.ACTION_SPIN = "doStart";
    this.ACTION_SPIN_WIN = "spinWin";
    this.ACTION_STOP  = "doStop";
    this.ACTION_SET_SETTINGS = "settingsSet";
    this.ACTION_SET_BET = "betSet";
    this.ACTION_SET_ACCOUNT = "accountSet";

    MinigameMathCommon.call(this,socket, MINIGAME_ID_COIN);

    this.m_model = {
        "is_fake": true, // fake marker
        "settings": {
            "background":1,
            "bet_type": null
        },
        "state" : {
            "bet": {
                "value": 50,
                "currency": {
                    "code_name" : "Cr"
                },
                "side": "head"
            },
            "coin": {
                "side": "tail",
                "state": "stop"
            },
            "history" : [
                {
                    "side": "head",
                    "bet": "tail"
                }
            ]
        },
        "account": {
            "uuid" : "2353",
            "currency": {
                "code_name" : "Cr",
                "minor_unit": 0,
                "separator" : "."
            },
            "settings":  {
                "min" : 0,
                "max": 99999,
                "steps": [1,2,3,4,5,6]
            }
        },
        "actions": [
            "spin",
            "setBet",
            "setSettings"
        ]
    };
}

MinigameMathCoin.prototype = Object.create(MinigameMathCommon.prototype);
MinigameMathCoin.prototype.constructor = MinigameMathCoin;

// MinigameMathCoin.prototype.__validateModel = function(model) {
//     if(!model.state.bet ) {
//         model.state.bet = {
//             "value": null,
//             "side": null,
//             "currency": {
//                 "code_name": ""
//             }
//         };
//     }
//
//     return model;
// };

// перенесо в базовый класс
//MinigameMathCoin.prototype.isActionAvailable = function(action_name) {
//    return this.m_model.actions.find( function(el) {return el == action_name;}) !== undefined;
//};


/**
 * возвращает размер ставки для кнопки номер index
 * @param {integer}      index
 * @return {integer}
 */

MinigameMathCoin.prototype.getBetValueVariant = function(index) {
    return this.m_model.account.settings.steps[index];
};

/**
 * Start coin spin
 * @param {bet|null}      bet
 * @param {function(e,r)} cb
 */
MinigameMathCoin.prototype.doSpin = function(bet, cb) {
    var params = {};
    if(bet !== null || bet !== undefined)
        params = {"bet":bet};

    this.localBalanceChange(-this.m_model.state.bet.value);
    //set state spin

    this.m_model.state.coin.state = "spin";
    this.m_model.state.coin.side = "?";
    // this.localStateChange(this.m_model.state);
    this.m_minigame_connector.doAction("doStart", params , cb);
};



/**
 * Start coin spin for win
 * @param {bet|null}      bet
 * @param {function(e,r)} cb
 */
MinigameMathCoin.prototype.doSpinWin = function(bet, cb) {
    var params = {};
    if(bet !== null || bet !== undefined)
        params = {"bet":bet};

    this.m_minigame_connector.doAction("spinWin", params , cb);
};



MinigameMathCoin.prototype.localStateChange = function(state) {
    // this.m_model.state = state;
    // this.m_model.actions = [];
    // вызовет mathNet.cb_model_changed = m => space.s( 'net' ).next( m ) и отключит анимацию ожидания s('pending')
    // поэтому вызывать s('pending') после изменения локальной модели
    this.__onGameModelChanged(this.m_model);
};


/**
 * Stop spining coin - add history
 * @param {function(e,r)} cb
 */
MinigameMathCoin.prototype.doStop = function(cb) {
    var params = {};

    this.m_model.state.coin.state = "stop";
    // this.localStateChange(this.m_model.state);

    this.m_minigame_connector.doAction("doStop", params , cb);
};



MinigameMathCoin.prototype.doTake = function(cb) {
    var win_value = (this.getWin()).value;
    this.m_model.state.win = null; // clear win
    // this.localStateChange(this.m_model.state);
    this.localBalanceChange(win_value);

    this.m_minigame_connector.doAction("doTake", {}, cb);
};


MinigameMathCoin.prototype.getWin = function() {
    return this.m_model.state.win;
};


MinigameMathCoin.prototype.setBetValue = function(bet_value) {
    if(bet_value > this.m_player_info.account.value)
        return false;
    if(!this.m_model.state.bet)
        this.m_model.state.bet = {};

    this.m_model.state.bet.value = bet_value;
    this.m_model.state.bet.currency = this.m_player_info.account.currency;
    this.m_model.state.bet.origin_account = {
        uuid: this.m_player_info.account.uuid
    };
    return true;
};

MinigameMathCoin.prototype.setBetSide = function( side ) {
    if(!this.m_model.state.bet)
        this.m_model.state.bet = {};
    this.m_model.state.bet.side = side;
    this.m_model.state.bet.currency = this.m_player_info.account.currency;
    this.m_model.state.bet.origin_account = {
        uuid: this.m_player_info.account.uuid
    };
};

/**
 * set current bet
 * @param {bet} bet
 * @param {function(e,r)} cb
 */
MinigameMathCoin.prototype.doSetBet = function(bet, cb) {
    this.m_minigame_connector.doAction("betSet", {"bet":bet} , cb);
};

/**
 * set settings
 * @param {object} settings
 * @param {function(e,r)} cb
 */
MinigameMathCoin.prototype.doSetSettings = function(settings, cb) {
    this.m_minigame_connector.doAction("settingsSet", {"settings":settings} , cb);
};



// WEBPACK FOOTER //
// ./src/library/minigame_client/coin/MinigameMathCoin.js